export default {
      id: "heart-usage",
      viewBox: "0 0 40 40",
      url: __webpack_public_path__ + "img/icons.e22fd14f.svg#heart",
      toString: function () {
        return this.url;
      }
    }